export const environment = {
      production: true,
      version: '3.1.9',
      stage: 'production',
      identifier: 'production',
      timestamp: '2026-11-03T20:28:13.854Z',
      SHARE_BASE_URL: 'https://share.vuframe.com/',
      API_BASE_URL: window.location.origin + '/api/vf/',
      CDN_BASE_URL: window.location.origin + '/api/vf/cdn/',
      CLOUDFRONT_CDN: true,
      BUGSNAG_API_KEY: 'MjM0ZWE1NzM2YTU5MmI0MmZkY2E0ODMzZmM1N2NlOWQ=',
      SHARE_V2_URL: 'https://share.vuframe.com',
      vercelAnalytics: false
    };
    